import React, { useEffect, useState, useContext } from 'react';
import './GHGEmissions.scss';
import { withTranslation } from 'react-i18next';
import { Button, Table, Modal, Form, Dropdown, OverlayTrigger, Tooltip, ProgressBar } from 'react-bootstrap';
import Pagination from '../../../components/Pagination/Pagination';
import { toast } from "react-toastify";
import { LoaderContext } from '../../../App';
import { LS_REGULATION_SELECTED_KEY } from '../../../core/constants/common';
import GHGEmissionService from '../../../core/service/GHGEmissionService';
import { DC_ITEMS_PER_PAGE } from '../../../core/constants/common';
import moment from "moment";
import Utils from '../../../core/utilities/Utils';
import CategorySearch from './CategorySearch';
import { FcFinePrint } from "react-icons/fc";
import CompanyService from '../../../core/service/CompanyService';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
import ReactDatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import AddCollectionData from './AddCollectionData';
import { BiPlus, BiPencil } from "react-icons/bi";
import esg_ai_pic from "../../../images/esg_ai_Green.png";
import { DATA_COLLECTION_IMPORT_POLLING_INTERVAL } from "../../../core/constants/common";
import esg_ai from '../../../images/esg_ai.png';

const EditDataCollection = ({ t }) => {

    const userData = JSON.parse(localStorage.getItem('userOnboardData') || '{}');
    const companyId = userData?.companyId || null;
    const glbRegulationId = localStorage.getItem(LS_REGULATION_SELECTED_KEY);
    const { setLoaderDisplay } = useContext(LoaderContext);
    const [itemsTotalCount, setItemTotalCount] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(DC_ITEMS_PER_PAGE);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataCollection, setDataCollection] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [dbData, setDbData] = useState([]);
    const [selectedDb, setSelectedDb] = useState('NAICS');
    const [parentEntities, setParentEntities] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [childEntities, setChildEntities] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedData, setSelectedData] = useState([]);
    const navigate = useNavigate();
    const [showAddModal, setShowAddModal] = useState(false);
    const [aiStatus, setAiStatus] = useState({});
    const [showConfirmationMapping, setShowConfirmationMapping] = useState(false);
    const [selectAllItems, setSelectAllItems] = useState(false);
    const [jobId, setJobId] = useState('');
    const [importInProgress, setImportInProgress] = useState(false);
    let importStatusPoller;

    useEffect(() => {
        dbInfo();
    }, []);

    useEffect(() => {
        if (!selectedEntity) return;
        clearImportStatusPoller();
        setSelectedItems([]);
        getDataCollection(0, itemsPerPage);
        fetchJobIDForAI();
        return () => {
            // On unmounting
            clearImportStatusPoller();
        };
    }, [selectedEntity]);

    useEffect(() => {
        if (!glbRegulationId) return;
        getEnterprisesByLevel(1);
        getEnterprisesByLevel(2);
    }, [glbRegulationId]);

    // useEffect(() => {
    //     if (jobId && jobId.id > 0) {
    //         fetchImportStatus(true);
    //     }
    // }, [jobId]);

    const fetchImportStatus = (startPoller = false) => {
        if (!companyId || !selectedEntity || !jobId?.id) return;
        GHGEmissionService.categoryWithAIStatus(
            companyId, selectedEntity, jobId.id).then((res) => {
                setAiStatus(res.data);
                if (res.data?.status === 'In Progress') {
                    setImportInProgress(true);
                    if (!startPoller) return;
                    startImportStatusPoller();
                } else {
                    clearImportStatusPoller();
                }
            }).catch(err => {
                clearImportStatusPoller();
            });
    };

    const startImportStatusPoller = () => {
        importStatusPoller = setTimeout(function request() {
            fetchImportStatus();
            importStatusPoller = setTimeout(request, DATA_COLLECTION_IMPORT_POLLING_INTERVAL);
        }, DATA_COLLECTION_IMPORT_POLLING_INTERVAL);
    };

    const clearImportStatusPoller = () => {
        setImportInProgress(false);
        setAiStatus({})
        if (!importStatusPoller) return;
        clearTimeout(importStatusPoller);
    };

    const getEnterprisesByLevel = (level) => {
        CompanyService.getEnterprisesByLevel(level).then(res => {
            if (res.status !== 200) return;
            const entities = res.data.sort((a, b) => a.sortOrder - b.sortOrder);
            if (level === 1) {
                setParentEntities(entities);
            } else if (level === 2) {
                setChildEntities(entities);
            }
        }).catch(err => { });
    };

    const getDataCollection = (pageNumber, itemsPerPageVal) => {
        let perPage = '';
        if (pageNumber > 0) {
            pageNumber = pageNumber - 1;
        } else {
            setCurrentPage(1);
        }
        if (itemsPerPageVal > 0) {
            perPage = itemsPerPageVal;
        } else {
            perPage = itemsPerPage;
        }
        if (!companyId || !selectedEntity) return;
        setDataCollection([]);
        setLoaderDisplay(true);
        GHGEmissionService.getDataCol(
            companyId,
            selectedEntity,
            pageNumber,
            perPage,
            'FINALIZED',
            glbRegulationId
        ).then((response) => {
            const totalPages = parseFloat(response.headers["x-total-count"] || 0);
            setItemTotalCount(isNaN(totalPages) || totalPages < 0 ? 0 : totalPages);
            let result = response.data ? response.data : [];
            // result.forEach(element => {
            //     element['isEdit'] = false;
            // });
            setDataCollection(result);
            setLoaderDisplay(false);
        })
            .catch((error) => {
                setLoaderDisplay(false);
            });
    };

    const renderEmptyDataLabel = () => {
        return (
            <tr className="Nodatafound_box">
                <td colSpan={10} className='text-center'><FcFinePrint className="me-2" />{t("Nodatafound.label")}</td>
            </tr>
        )
    };

    const onPageSelection = (id) => {
        const ids = [...selectedItems];
        const index = selectedItems.indexOf(id);
        if (index >= 0) {
            ids.splice(index, 1);
        } else {
            ids.push(id);
        }
        setSelectedItems(ids);
    };

    const onSelectAllPages = () => {
        if (dataCollection.length === selectedItems.length) {
            setSelectedItems([]);
            return;
        }
        const ids = [];
        dataCollection?.forEach(data => {
            ids.push(data.id);
        });
        setSelectedItems(ids);
    };

    const addCategory = (cat) => {
        let dataCol = JSON.parse(JSON.stringify(dataCollection));
        dataCol.forEach(element => {
            if (selectedItems.includes(element.id)) {
                element['refUSEEIOCode'] = cat['refUSEEIOCode'];
                element['factorWithMargins'] = cat['factorWithMargins'];
                element['categoryName'] = cat['title'];
                element['code'] = cat['code'];
                element['factorId'] = cat['id'];
                element['db'] = selectedDb;
            }
        });
        setDataCollection(dataCol);
        setShowModal(false);
    }

    const dbInfo = () => {
        setLoaderDisplay(true);
        GHGEmissionService.getDBInfo().then((response) => {
            setLoaderDisplay(false);
            setDbData(response.data);
        })
            .catch((error) => {
                setLoaderDisplay(false);
            });
    }

    const showCategoryModal = () => {
        if (selectedDb && selectedItems.length > 0) {
            setShowModal(true);
        } else {
            toast.warning("Please select items for category mapping", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }
    }

    const editPurchasedItem = () => {
        if (!companyId || !selectedEntity) return;
        if (selectedDb) {
            setLoaderDisplay(true);
            GHGEmissionService.editCollectionItem(
                dataCollection,
                selectedDb,
                companyId,
                selectedEntity,
                glbRegulationId
            ).then((response) => {
                setLoaderDisplay(false);
                toast.success("Data updated successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setSelectedItems([]);
                setIsEdit(false);
                getDataCollection(0, itemsPerPage);
            })
                .catch((error) => {
                    setLoaderDisplay(false);
                });
        } else {
            toast.warning("Please choose emission table to update", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }
    }

    const processEdit = () => {
        if (dataCollection.length > 0) {
            setIsEdit(true);
        }
    }

    const addNewItem = () => {
        setShowAddModal(true);
    }

    const patchPeriod = (data, index) => {
        let dataCol = [...dataCollection]
        dataCol[index]['period'] = moment(data).format('YYYY-MM-DD');
        setDataCollection(dataCol);
    }

    const handleChange = (e, index, columnName) => {
        let dataCol = [...dataCollection]
        dataCol[index][columnName] = e.target.value;
        setDataCollection(dataCol);
    };

    const renderEditableFields = (data, index, type) => {
        return (
            <Form>
                {
                    type == 'item' &&
                    <div className='w-100 d-flex'>
                        <div className='w-100'>
                            <input
                                type="text"
                                className="form-control "
                                id={`item-${index}`}
                                defaultValue={data}
                                name="item"
                                onChange={(e) => { handleChange(e, index, 'item') }}
                            />
                        </div>
                    </div>
                }
                {
                    type == 'supplier' &&
                    <div className='w-100 d-flex'>
                        <div className='w-100'>
                            <input
                                type="text"
                                className="form-control "
                                id={`supplier-${index}`}
                                defaultValue={data}
                                name="supplier"
                                onChange={(e) => { handleChange(e, index, 'supplier') }}
                            />
                        </div>
                    </div>
                }
                {
                    type == 'uom' &&
                    <div className='w-100 d-flex'>
                        <div className='w-100'>
                            <input
                                type="text"
                                className="form-control "
                                id={`uom-${index}`}
                                defaultValue={data}
                                name="uom"
                                onChange={(e) => { handleChange(e, index, 'uom') }}
                            />
                        </div>
                    </div>
                }
                {
                    type == 'quantity' &&
                    <div className='w-100 d-flex'>
                        <div className='w-100'>
                            <input
                                type="number"
                                className="form-control "
                                id={`quantity-${index}`}
                                defaultValue={data}
                                name="quantity"
                                onChange={(e) => { handleChange(e, index, 'quantity') }}
                            />
                        </div>
                    </div>
                }
                {
                    type == 'costInUSD' &&
                    <div className='w-100 d-flex'>
                        <div className='w-100'>
                            <input
                                type="number"
                                className="form-control "
                                id={`costInUSD-${index}`}
                                defaultValue={data}
                                name="costInUSD"
                                onChange={(e) => { handleChange(e, index, 'costInUSD') }}
                            />
                        </div>
                    </div>
                }
                {
                    type == 'period' &&
                    <ReactDatePicker
                        selected={new Date(data)}
                        className="form-control "
                        onChange={(date) => { patchPeriod(date, index) }}
                        dateFormat="dd/MM/yyyy"
                    />
                }
            </Form>
        );
    }

    const cancelEdit = () => {
        setIsEdit(false);
    }

    const backToDataView = () => {
        navigate({
            pathname: "/company_admin/dataview",
        });
    }

    const aiMapCategory = (job) => {
        if (!companyId || !selectedEntity) return;
        if (dataCollection.length > 0) {
            setLoaderDisplay(true);
            GHGEmissionService.mapCategoryWithAI(
                selectedDb,
                companyId,
                selectedEntity,
                job
            ).then((response) => {
                setLoaderDisplay(false);
                toast.success("AI mapping initiated", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                fetchJobIDForAI();
            })
                .catch((error) => {
                    setLoaderDisplay(false);
                });
        } else {
            toast.warning("No items for AI mapping", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }
    }

    const aiMapCategoryStatus = () => {
        if (!companyId || !selectedEntity) return;
        setLoaderDisplay(true);
        GHGEmissionService.categoryWithAIStatus(
            companyId,
            selectedEntity,
            jobId
        ).then((response) => {
            setLoaderDisplay(false);
            setAiStatus(response.data);
        })
            .catch((error) => {
                setLoaderDisplay(false);
            });
    }

    const aiSelectedMapCategory = (job) => {
        if (!companyId || !selectedEntity) return;
        if (dataCollection.length > 0 && selectedItems.length > 0) {
            setLoaderDisplay(true);
            GHGEmissionService.mapSelectedCategoryWithAI(
                { id_list: selectedItems },
                selectedDb,
                companyId,
                selectedEntity,

                job
            ).then((response) => {
                setLoaderDisplay(false);
                toast.success("AI mapping for selected items is initiated", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setJobId({ id: response.data.job });
            })
                .catch((error) => {
                    setLoaderDisplay(false);
                });
        } else {
            toast.warning("No items selected for AI mapping", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }
    }

    const confirmMapping = (val) => {
        setShowConfirmationMapping(false);
        if (val) {
            createJobIDForAI();
        }
    }

    const createJobIDForAI = () => {
        if (!companyId || !selectedEntity) return;
        setLoaderDisplay(true);
        GHGEmissionService.createJobIdForAI(companyId, selectedEntity)
            .then((response) => {
                setLoaderDisplay(false);
                if (response.data > 0) {
                    if (selectedItems.length == 0) {
                        aiMapCategory(response.data);
                    } else {
                        aiSelectedMapCategory(response.data)
                    }
                }
            })
            .catch((error) => {
                setLoaderDisplay(false);
            });
    }

    const fetchJobIDForAI = () => {
        if (!companyId || !selectedEntity) return;
        GHGEmissionService.getJobIdForAI(companyId, selectedEntity)
            .then((response) => {
                setJobId(response.data);
                if (response.data.id > 0) {
                    fetchImportStatus(true);
                } else {
                    clearImportStatusPoller();
                }
            })
            .catch((error) => {
            });
    }

    return (
        <div className='Verify_dataBox'>
            <div className="List_header">
                <h5 className="MH">{t("GHGDataCollection.label")}</h5>
                <div>
                    <Button
                        type="button"
                        variant='primary'
                        className="me-2"
                        disabled={dataCollection.length == 0 || aiStatus.status === 'In Progress'}
                        onClick={() => {
                            addNewItem()
                        }}>
                        <BiPlus className='me-2' />
                        {t("New.label")}
                    </Button>
                    <Button
                        variant='secondary'
                        type="button"
                        disabled={dataCollection.length == 0 || aiStatus.status === 'In Progress'}
                        onClick={() => {
                            processEdit()
                        }}>
                        <BiPencil className='me-2' />
                        {t("Edit.label")}
                    </Button>
                </div>
            </div>
            <div className='row m-0 entityFilterbox'>
                <div className="pt-1 pb-2 px-0 col-md-3 d-flex align-items-center">
                    {/* <label className='me-2 white-space'>{t("Entity.label")} :</label> */}
                    <select className="form-select "
                        value={selectedEntity || ''}
                        onChange={(e) => {
                            setSelectedEntity(e.target.value);
                        }}>
                        <option key='' value=''>{t("SelectEntity.label")}</option>
                        {
                            parentEntities?.map((items) => (
                                <option value={items.id} key={items.id}>
                                    {items.name}
                                </option>
                            ))
                        }
                        {
                            childEntities?.map((items) => (
                                <option value={items.id} key={items.id}>
                                    {items.name}
                                </option>
                            ))
                        }
                    </select>
                </div>

                <div className='entityFilterbox_inner col-md-9 p-0'>
                    <div>
                        {
                            (aiStatus.status === 'In Progress') &&
                            <span className="mx-2 Report_generatBox">
                                <div className="spinner-8"></div>
                                {t('MappingProcessing.label')} {'(' + aiStatus.completed + '/' + aiStatus.total + ')'}
                            </span>
                        }
                    </div>
                    <div className="py-2 px-0 pe-2 col-md-3">
                        <div className='d-flex align-items-center'>
                            {/* <label htmlFor="emissionTable" className='me-2 white-space'>{t("EmissionTable.label")} : </label> */}
                            <select id="emissionTable"
                                className="form-select "
                                onChange={(e) => setSelectedDb(e.target.value)}
                                value={selectedDb}>
                                <option key='' value='' disabled>{t("SelectEmissionTable.label")}</option>
                                {
                                    dbData.length > 0 && (
                                        dbData?.map(d => {
                                            return <option key={d} value={d}>{d}</option>;
                                        })
                                    )
                                }
                            </select>
                        </div>
                    </div>
                    <div className="py-2 px-0">
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-like">{t("MapHelpText.label")}</Tooltip>} >
                            <Button
                                variant='primary'
                                type="button"
                                className="mx-2"
                                disabled={dataCollection.length == 0 || aiStatus.status === 'In Progress'}
                                onClick={() => {
                                    showCategoryModal()
                                }}>
                                {t("MapCategory.label")}
                            </Button>
                        </OverlayTrigger>

                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-like">{t("MapWithAIHelpText.label")}</Tooltip>} >
                            <Button
                                variant='ESGAi'
                                type="button"
                                disabled={!selectedEntity || dataCollection.length == 0 || aiStatus.status === 'In Progress'}
                                onClick={() => {
                                    setShowConfirmationMapping(true);
                                }}>
                                <img src={esg_ai} width={15} height={15} alt="ESG AI" /> {t("MapWithAI.label")}
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>

            {
                !isEdit &&
                <div className=''>
                    <div className='EntityFinalizeTable EditGHGData_tb'>
                        <Table responsive bordered className='mb-0'>
                            <thead>
                                <tr>
                                    <th>
                                        {/* <Dropdown>
                                            <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input cursor"
                                                    id={`selectAllpageCheckbox`}
                                                    checked={selectedItems?.length === dataCollection.length}
                                                    disabled
                                                />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item href="#" onClick={() => onSelectAllPages()}>Select This Page</Dropdown.Item>
                                                <Dropdown.Item href="#" onClick={() => { setSelectAllItems(true); onSelectAllPages() }}>Select All</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown> */}
                                        <input
                                            type="checkbox"
                                            className="form-check-input cursor"
                                            id={`selectAllpageCheckbox`}
                                            checked={selectedItems?.length === dataCollection.length}
                                            onChange={() => onSelectAllPages()}
                                        />
                                    </th>
                                    <th>Period</th>
                                    <th>Item</th>
                                    <th>Supplier</th>
                                    <th>Quantity</th>
                                    <th>UOM </th>
                                    <th>Cost In USD</th>
                                    <th>Category</th>
                                    <th>Ref USEEIO Code</th>
                                    <th>Emission Factor</th>
                                    {/* <th>Confidence</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {dataCollection.length > 0 ? (
                                    dataCollection.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input cursor"
                                                    id={`pageCheckbox-${index}`}
                                                    checked={selectedItems.indexOf(item.id) >= 0}
                                                    onChange={() => onPageSelection(item.id)}
                                                />
                                            </td>
                                            <td className='white-space'>{moment(item.period).format("MMM DD, YYYY")}</td>
                                            <td>{item.item}</td>
                                            <td>{item.supplier}</td>
                                            <td>{Utils.formattedNumber(item.quantity)}</td>
                                            <td className='uom_tb'>{item.uom}</td>
                                            <td>{Utils.formattedNumber(item.costInUSD)}</td>
                                            <td className='Category_td'>
                                                <div className='category_name_td'>
                                                    {item?.categoryName}
                                                    {item?.aiFlag &&
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={Utils.renderTooltip(
                                                                `AI mapped with ${item?.confidence ?? 0}% confidence`
                                                            )}>
                                                            <span className="AI_Icon_DC">
                                                                <img src={esg_ai_pic} />
                                                            </span>
                                                        </OverlayTrigger>
                                                    }
                                                </div>
                                            </td>
                                            <td>{item.refUSEEIOCode}</td>
                                            <td>{item.factorWithMargins}</td>
                                            {/* <td>
                                                {item?.aiFlag &&
                                                    <div style={{ width: 40, height: 40 }}>
                                                        <CircularProgressbar value={item?.confidence ?? 0}
                                                            styles={buildStyles({
                                                                pathColor: getColor(item?.confidence),
                                                                textColor: getColor(item?.confidence),
                                                                trailColor: '#dee8ed'
                                                            })}
                                                            text={`${item?.confidence ?? 0}%`} strokeWidth={10} />
                                                    </div>
                                                }
                                            </td> */}
                                        </tr>
                                    ))
                                ) :
                                    renderEmptyDataLabel()
                                }
                            </tbody>
                        </Table>
                    </div>
                    <div className="py-2 List_footer_count">
                        <Pagination
                            itemsTotalCount={itemsTotalCount}
                            itemsPerPage={itemsPerPage}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            alwaysShown={true}
                            setItemsPerPage={setItemsPerPage}
                            pageClicked={(pageNum, perPage) => {
                                getDataCollection(pageNum, perPage);
                            }}
                            pageInfo={'DataCollection'}
                        />
                    </div>
                    <div className='text-center GHGData_footer px-2'>
                        <Button variant='secondary' className='px-3 me-2' onClick={() => backToDataView()}>{t("Exit.label")}</Button>
                        <Button variant='primary' className='px-3' onClick={() => editPurchasedItem()} disabled={aiStatus.status === 'In Progress'}>{t("Save.label")}</Button>
                    </div>
                </div>
            }

            {
                isEdit &&
                <div className="">
                    <div className="EntityFinalizeTable_edit">
                        <Table responsive striped bordered className='m-0'>
                            <thead>
                                <tr>
                                    <th className='Period'>Period</th>
                                    <th className='Item'>Item</th>
                                    <th>Supplier</th>
                                    <th className='Quantity'>Quantity</th>
                                    <th className='UOM'>UOM </th>
                                    <th className='Cost'>Cost In USD</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    dataCollection.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{renderEditableFields(item.period, index, 'period')}</td>
                                            <td>{renderEditableFields(item.item, index, 'item')}</td>
                                            <td>{renderEditableFields(item.supplier, index, 'supplier')}</td>
                                            <td>{renderEditableFields(item.quantity, index, 'quantity')}</td>
                                            <td>{renderEditableFields(item.uom, index, 'uom')}</td>
                                            <td>{renderEditableFields(item.costInUSD, index, 'costInUSD')}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </div>
                    <div className='text-center p-2'>
                        <Button variant='secondary' className='px-3 me-2' onClick={() => cancelEdit()}>Cancel</Button> &nbsp;
                        <Button variant='primary' className='px-3' onClick={() => editPurchasedItem()}>{t("Update.label")}</Button>
                    </div>
                </div>
            }

            {
                showModal &&
                <CategorySearch db={selectedDb} onShowModal={showModal} onHideModal={(val) => setShowModal(val)} onAddCategory={(cat) => addCategory(cat)} />
            }

            {
                showAddModal &&
                <AddCollectionData onShowModal={showAddModal} onHideModal={(val) => { setShowAddModal(val); getDataCollection(0, itemsPerPage); }} db={selectedDb} companyId={companyId} entity={selectedEntity} glbRegulationId={glbRegulationId} />
            }

            {showConfirmationMapping && (
                <ConfirmationModal
                    modalShow={true}
                    messageText={t("AIMappingModal.label")}
                    callbackModal={confirmMapping}
                    confirmBtn={t("Confirm.label")}
                    CancelBtn={t("Cancel.label")}
                />
            )}

        </div>
    );
};

export default withTranslation()(EditDataCollection);